import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedAnimations } from '@stockcare-shared/animations/animations';
import { MaterialsListComponent } from '@stockcare-components/materials-list/materials-list.component';
import { TheatreBasketPack } from '@stockcare-models/TheatreBasketPack';
import { TheatreBasketPackMaterial } from '@stockcare-models/TheatreBasketPackMaterial';
import { NotificationService } from '@stockcare-services/notification-service/notification.service';
import { TheatreBasketPackMaterialAdjustment } from '@stockcare-models/TheatreBasketPackMaterialAdjustment';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { TheatreBasketItem } from '@stockcare-models/TheatreBasketItem';
import { TheatreBasketPackService } from '@stockcare-models/TheatreBasketPackService';
import { MaterialType } from '@stockcare-models/MaterialType';
import { AuthenticationService } from '@stockcare-services/index';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';

@Component({
  standalone: false,
  selector: 'app-pack-accordion',
  templateUrl: './pack-accordion.component.html',
  styleUrls: ['./pack-accordion.component.scss'],
  animations: [SharedAnimations],
})
export class PackAccordionComponent implements OnInit, OnDestroy {
  @ViewChild(MaterialsListComponent)
  private materialListComponent: MaterialsListComponent;
  @Input()
  pack = new TheatreBasketPack();
  @Input() allPacks: TheatreBasketPack[];
  @Input() allBasketItems: TheatreBasketItem[];
  @Output() removeFromBasket: EventEmitter<TheatreBasketPack> = new EventEmitter();
  @Output() updateMaterialQuantity: EventEmitter<TheatreBasketPackMaterialAdjustment> = new EventEmitter();
  @Output() removeServiceFromPack: EventEmitter<TheatreBasketPackService> = new EventEmitter();
  toggleState: boolean;

  canDeletMaterial: boolean;
  canIncreaseMaterialQuantity: boolean;
  canDecreaseMaterialQuantity: boolean;
  isTheatreBackOfficeDevice: boolean;

  constructor(private notify: NotificationService, private readonly settingsService: SettingsService, private readonly authenticationService: AuthenticationService, private readonly deviceService: DeviceService) { }

  ngOnInit() {
    this.canDeletMaterial = this.settingsService.getBooleanSetting('enablePackMaterialDeletion');
    this.canIncreaseMaterialQuantity = this.settingsService.getBooleanSetting('enablePackMaterialIncreaseQuantity');
    this.canDecreaseMaterialQuantity = this.settingsService.getBooleanSetting('enablePackMaterialDecreaseQuantity');
    this.isTheatreBackOfficeDevice = this.deviceService.isTheatreBackOfficeDevice();
  }

  removePackFromBasket() {
    this.removeFromBasket.emit(this.pack);
  }

  async incrementMaterialQuantity(material: TheatreBasketPackMaterial) {
    if (!this.isTheatreBackOfficeDevice) {
      if (this.validateStockQuantity(material.barcode, material.availableStock)) {
        this.notify.error('No stock available');
      } else {
        material.userName = this.authenticationService.getUsername();
        const adjustment: TheatreBasketPackMaterialAdjustment = {
          material: material,
          currentQuanity: material.packQuantity,
          quantityToAdjust: -1,
        };
        material.packQuantity++;
        this.updateMaterialQuantity.emit(adjustment);
      }
    }else{
      this.notify.error('Edits cannot be made using Theatre Back Office Devices');
    }

  }

  updateQuantity(material: TheatreBasketPackMaterial, quantity: number) {
    if (!this.isTheatreBackOfficeDevice) {
      const adjustment: TheatreBasketPackMaterialAdjustment = {
        material: material,
        currentQuanity: material.packQuantity,
        quantityToAdjust: material.packQuantity - quantity,
      };
      material.packQuantity = quantity;
      this.updateMaterialQuantity.emit(adjustment);
    }else{
      this.notify.error('Edits cannot be made using Theatre Back Office Devices');
    }
  }

  decrementMaterialQuantity(material: TheatreBasketPackMaterial) {
    if (!this.isTheatreBackOfficeDevice) {
      if (material.packQuantity > 0) {
        const adjustment: TheatreBasketPackMaterialAdjustment = {
          material: material,
          currentQuanity: material.packQuantity,
          quantityToAdjust: 1,
        };
        material.packQuantity--;
        this.updateMaterialQuantity.emit(adjustment);
      }
    }else{
      this.notify.error('Edits cannot be made using Theatre Back Office Devices');
    }
  }

  removeFromPack(material: TheatreBasketPackMaterial) {
    if (!this.isTheatreBackOfficeDevice) {
      const adjustment: TheatreBasketPackMaterialAdjustment = {
        material: material,
        currentQuanity: material.packQuantity,
        quantityToAdjust: material.packQuantity,
      };
      material.packQuantity = 0;
      this.updateMaterialQuantity.emit(adjustment);
    }else{
      this.notify.error('Edits cannot be made using Theatre Back Office Devices');
    }
  }

  removeServicesFromPack(service: TheatreBasketPackService) {
    if (!this.isTheatreBackOfficeDevice) {
      this.removeServiceFromPack.emit(service);
    }else{
      this.notify.error('Edits cannot be made using Theatre Back Office Devices');
    }
  }

  validateStockQuantity(barcode: String, availableStock: number): boolean {
    const existingMaterial = this.allBasketItems.find(
      (x) => x.barcode === barcode && x.packId === null
    );

    var totalPackQuantity = 0;

    this.allPacks
      .forEach((pack) => {
        pack.materials
          .filter((m) => m.packQuantity > 0 && m.barcode === barcode)
          .forEach((pm) => {
            totalPackQuantity += pm.packQuantity;
          });
      });

    var totalQuantity = existingMaterial == undefined ? totalPackQuantity : totalPackQuantity + existingMaterial.quantity

    if (totalQuantity >= availableStock) {
      return true;
    }
    return false;
  }

  ngOnDestroy() { }

  itemClassName(item: TheatreBasketPackMaterial): string {
    let name = `item-${MaterialType.Materials}-${item.materialId}`;
    return name.toLocaleLowerCase();
  }
}
